export default __webpack_public_path__ + "static/media/background2.821f30f8.jpg";